import React from 'react';
import GenericCrudPage from '../components/GenericCrudPage';

// Leads Management
export const LeadsPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="leads"
    title="Leads Pipeline"
    fields={[
      { key: 'name', label: 'Name', required: true },
      { key: 'phone', label: 'Phone', required: true },
      { key: 'email', label: 'Email', type: 'email' },
      { key: 'source', label: 'Source', type: 'select', options: ['google', 'facebook', 'instagram', 'referral', 'walk-in', 'justdial', 'other'] },
      { key: 'interestedIn', label: 'Interested In' },
      { key: 'assignedTo', label: 'Assigned To' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
      { key: 'status', label: 'Status', type: 'select', options: ['new', 'contacted', 'qualified', 'proposal-sent', 'converted', 'lost'], default: 'new' },
    ]}
    listColumns={['name', 'phone', 'source', 'interestedIn', 'assignedTo', 'status']}
  />
);

// AI Imaging Analysis
export const AiImagingPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="ai-imaging"
    title="AI Imaging Analysis"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'imageType', label: 'Image Type', type: 'select', options: ['OPG', 'IOPA', 'CBCT', 'intraoral-photo', 'cephalogram'] },
      { key: 'imageUrl', label: 'Image URL', required: true },
      { key: 'aiFindings', label: 'AI Findings', type: 'textarea' },
      { key: 'doctorReview', label: 'Doctor Review', type: 'textarea' },
      { key: 'analysisDate', label: 'Analysis Date', type: 'date' },
      { key: 'status', label: 'Status', type: 'select', options: ['pending', 'analyzed', 'reviewed'], default: 'pending' },
    ]}
    listColumns={['analysisDate', 'patientName', 'imageType', 'status']}
  />
);

// DSLR Photography Gallery
export const DslrPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="dslr"
    title="Clinical Photography (DSLR)"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'photoType', label: 'Photo Type', type: 'select', options: ['before', 'after', 'progress', 'portrait', 'smile', 'intraoral'] },
      { key: 'description', label: 'Description' },
      { key: 'imageUrl', label: 'Image URL', required: true },
      { key: 'capturedBy', label: 'Captured By' },
      { key: 'captureDate', label: 'Capture Date', type: 'date' },
      { key: 'tags', label: 'Tags (comma separated)' },
    ]}
    listColumns={['captureDate', 'patientName', 'photoType', 'capturedBy']}
  />
);

// OneDrive Backup Management
export const OneDriveBackupPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="onedrive-backup"
    title="OneDrive Backups"
    fields={[
      { key: 'backupName', label: 'Backup Name', required: true },
      { key: 'backupType', label: 'Type', type: 'select', options: ['full', 'incremental', 'differential'] },
      { key: 'size', label: 'Size (MB)', type: 'number' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'driveUrl', label: 'OneDrive URL' },
      { key: 'status', label: 'Status', type: 'select', options: ['scheduled', 'running', 'completed', 'failed'], default: 'scheduled' },
    ]}
    listColumns={['date', 'backupName', 'backupType', 'size', 'status']}
  />
);

// Supplier Analytics
export const SupplierAnalyticsPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="supplier-analytics"
    title="Supplier Performance Analytics"
    fields={[
      { key: 'supplierName', label: 'Supplier Name', required: true },
      { key: 'totalOrders', label: 'Total Orders', type: 'number' },
      { key: 'onTimeDeliveryRate', label: 'On-Time %', type: 'number' },
      { key: 'qualityScore', label: 'Quality Score (1-10)', type: 'number' },
      { key: 'priceCompetitiveness', label: 'Price Score (1-10)', type: 'number' },
      { key: 'lastReviewDate', label: 'Last Review', type: 'date' },
      { key: 'rating', label: 'Overall Rating', type: 'select', options: ['excellent', 'good', 'average', 'poor'] },
    ]}
    listColumns={['supplierName', 'totalOrders', 'onTimeDeliveryRate', 'qualityScore', 'rating']}
  />
);
